import axios, { AxiosRequestConfig } from 'axios'

import { InputEmailParam, IUser, PasswordSettingParam } from '@/types/user'
import { setAccessToken } from '@/api/axios-default'

import store from '@/store'

export const login = async (
  code: string,
  password: string,
): Promise<{ accessToken: string; ip: string }> => {
  const data = {
    code,
    password,
  }
  try {
    const response = await axios.post<{ access_token: string; ip: string }>(
      'auth/login',
      data,
    )
    const ipResponse = await axios.get<{ origin: string }>(
      'https://httpbin.org/ip',
    )
    return {
      accessToken: response.data.access_token,
      ip: ipResponse.data.origin,
    }
  } catch (error) {
    console.error(error)
    throw new Error('error.users.login')
  }
}

export const resetPassword = async (
  inputEmailParam: InputEmailParam,
): Promise<void> => {
  await axios.put<string>('auth/reset-password', inputEmailParam)
}

export const updatePassword = async (
  passwordSettingParam: PasswordSettingParam,
): Promise<void> => {
  await axios.put<IUser>('auth/update-password', passwordSettingParam)
}

export const getMe = async (): Promise<IUser> => {
  setAccessToken()
  try {
    const response = await axios.get<IUser>('auth/me')
    return response.data
  } catch (error) {
    store.dispatch('user/logout')
    throw new Error('error.users.getMe')
  }
}

export const createMultiUser = async (user: IUser): Promise<IUser> => {
  // eslint-disable-next-line
  const { id, createdAt, updatedAt, deletedAt, ...dto } = user
  try {
    const response = await axios.post<IUser>('users', dto)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.users.createMultiUser')
  }
}

export const getMultiUsers = async (
  lastId?: number,
  query?: any,
): Promise<[IUser[], number]> => {
  const config: AxiosRequestConfig = {}
  if (lastId) {
    config.params.lastId = lastId
  }
  if (query !== undefined) {
    config.params = {
      ...config.params,
      ...query,
    }
  }
  const instance = axios.create(config)
  try {
    const response = await instance.get<IUser[]>('users')
    const users = response.data
    const _users = users.sort((p: any, n: any) => {
      return p.id < n.id ? -1 : 1
    })
    return [_users, users.length]
  } catch (error) {
    console.error(error)
    throw new Error('error.users.getMultiUsers')
  }
}

export const getMultiUser = async (id: number): Promise<IUser> => {
  const instance = axios.create()
  try {
    const response = await instance.get<IUser>(`users/${id}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.users.getMultiUser')
  }
}

export const updateMultiUser = async (multiUser: IUser): Promise<IUser> => {
  try {
    const response = await axios.put<IUser>(`users/${multiUser.id}`, multiUser)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.users.updateMultiUser')
  }
}

export const deleteMultiUser = async (id: number): Promise<IUser> => {
  try {
    const response = await axios.delete<IUser>(`users/${id}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.users.deleteMultiUser')
  }
}
